// User related types
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  borrowerId?: string; // Borrower ID from the backend
  assignedSalespersonId?: string | null;
  assignedSalesperson?: AssignedSalespersonSummary | null;
  avatar?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssignedSalespersonSummary {
  id: string;
  name: string;
}

export enum UserRole {
  ADMIN = 'ADMIN',
  UNDERWRITER = 'UNDERWRITER',
  BORROWER = 'BORROWER',
  SALESPERSON = 'SALESPERSON',
  USER = 'USER',
  GUEST = 'GUEST',
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  fullName: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  city: string;
  state: string;
}

export interface AuthResponse {
  user: User;
  token: string;
  refreshToken?: string;
}
